/**
 * @generated SignedSource<<fe0ad3fec178d85248010c8093b31e43>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "UpdateAssetPayload",
            "kind": "LinkedField",
            "name": "updateAsset",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EdgeOfAsset",
                    "kind": "LinkedField",
                    "name": "assetEdge",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "color",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "SchedulableEntityColorRowUpdateAssetMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "SchedulableEntityColorRowUpdateAssetMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "91045ec629ec7210104d38b50ee68877",
            "id": null,
            "metadata": {},
            "name": "SchedulableEntityColorRowUpdateAssetMutation",
            "operationKind": "mutation",
            "text": "mutation SchedulableEntityColorRowUpdateAssetMutation(\n  $model: UpdateAssetRequestInput!\n) {\n  updateAsset(model: $model) {\n    assetEdge {\n      node {\n        id\n        color\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "23ffa6a3a3eed44c3f0aae7c0d7cf8ba";
export default node;
